import { qportalApi } from './qportal-api';
const addClient = (client) => {
    return qportalApi.post(`client`, client);
};
const getClients = () => {
    return qportalApi.get(`client`);
};
const getUnassignedClients = (Id) => {
    return qportalApi.get(`client/${Id}/getAllUnassignedClients`);
};
const getClientById = (Id) => {
    return qportalApi.get(`client/${Id}`);
};
const updateClient = (client) => {
    return qportalApi.put('client/updateClientAsync', client);
};
const getClientContractDocuments = (clientId) => {
    return qportalApi.get(`client/${clientId}/ClientContractDocuments`);
};
const ClientApi = {
    addClient,
    getClients,
    getUnassignedClients,
    getClientById,
    updateClient,
    getClientContractDocuments
};
export default ClientApi;
